var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('page-header',{attrs:{"page":_vm.page}}),_c('squareOption',{attrs:{"menu":_vm.optionList}}),_c('label',{staticStyle:{"font-size":"16px"}},[_vm._v(" 16 px ")]),_c('br'),_c('label',[_vm._v(" 14 px ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }